import styled from 'styled-components';

export const RuleBuilderHeader = styled.div`
  display: flex;
  justify-content: space-between;
  justify-items: center;
  padding: 10px 0;
`;

export const RuleBuilderTitle = styled.div`
  height: 20px;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;

  display: flex;
  align-items: center;
  letter-spacing: -0.01em;

  color: rgba(0, 0, 0, 0.65);
`;

export const DeleteAllButton = styled.div`
  height: 20px;
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.01em;
  color: rgba(0, 0, 0, 0.45);
  cursor: pointer;
`;

export const TransformFooter = styled.div<{ disabled?: boolean }>`
  width: 100%;
  height: 40px;

  display: flex;
  align-items: center;
  padding: 0 16px;
  gap: 12px;

  background: #f7f7f7;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
`;
